// extracted by mini-css-extract-plugin
export default {"copy":"SearchResults_copy__2Moci","title":"SearchResults_title__3n0v7"};